import { render, staticRenderFns } from "./WelcomeBox.vue?vue&type=template&id=b760b990&scoped=true"
import script from "./WelcomeBox.vue?vue&type=script&lang=js"
export * from "./WelcomeBox.vue?vue&type=script&lang=js"
import style0 from "./WelcomeBox.vue?vue&type=style&index=0&id=b760b990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b760b990",
  null
  
)

export default component.exports